import React, { useEffect, useRef, useState } from "react";
import styled, { css } from "styled-components";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

//assets
import doodle from "assets/svg/doodle-eyes.svg";


//styles
import typographySizes from "styles/typographySizes.js";
import distances from "styles/distances.js";
import mediaQuery from "styles/mediaQuery.js";
import colors from "styles/colors.js";

//components
import TextWithLineBreaks from "components/global/typography/TextWithLineBreaks.js";
import MainWrapper from "components/global/MainWrapper.js";
import ServicesItem from "components/home/services/ServicesItem.js";
import Btn from "components/global/Btn.js";
import Body from "components/global/typography/text/Body.js";
import PlayBtn from "components/home/header/PlayBtn.js";
import Media from "components/global/Media.js";
import Work from "components/global/works/Work.js";


const Wrapper = styled.div`
display: flex;
justify-content: space-between;
flex-wrap: wrap;

row-gap: 8rem;

 @media all and (max-width: ${mediaQuery.laptop}) {
  row-gap: 4rem;
 }
 
`;




const Works = ({ projects }) => {

  return (
    <Wrapper>

  {projects.map((project, index) => (
    <Work key={project.id} data={project} index={index} />
  ))}
    </Wrapper>
  );
};

export default Works;
